import React from "react";
import { ButtonPill } from "./ButtonPill.style";


export default ButtonPill;
